// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"c9dd80cb","541":"8d309401","595":"5ef4d79d","787":"ce1a5975","901":"8748695f"}[chunkId] + ".chunk.js";
};